import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";
import { useLang } from "@/i18n";

const CONSENT_KEY = "adtraining_cookie_consent";

export function CookieBanner() {
  const { t } = useLang();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      if (!localStorage.getItem(CONSENT_KEY)) setVisible(true);
    } catch {
      setVisible(true);
    }
  }, []);

  const choose = (value) => {
    try {
      localStorage.setItem(CONSENT_KEY, JSON.stringify({ value, at: new Date().toISOString() }));
    } catch {}
    if (typeof window.fbq === "function") {
      window.fbq("consent", value === "accepted" ? "grant" : "revoke");
      if (value === "accepted") window.fbq("track", "PageView");
    }
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div data-testid="cookie-banner"
      className="fixed bottom-4 inset-x-4 sm:inset-x-auto sm:right-6 sm:bottom-6 sm:max-w-md z-[100] kc-card p-5 shadow-2xl border-primary/30 kc-animate"
      role="dialog" aria-live="polite" aria-label={t("cookie.title")}>
      <div className="flex items-start gap-3">
        <Cookie className="w-5 h-5 text-primary shrink-0 mt-0.5" />
        <div className="flex-1">
          <p className="text-sm font-bold mb-1">{t("cookie.title")}</p>
          <p className="text-xs text-muted-foreground leading-relaxed mb-4">
            {t("cookie.text")}{" "}
            <Link to="/cookie-policy" data-testid="cookie-privacy-link" className="text-primary underline underline-offset-2">
              {t("cookie.privacyLink")}
            </Link>
          </p>
          <div className="flex gap-2">
            <button data-testid="cookie-accept" onClick={() => choose("accepted")}
              className="kc-btn-primary !px-5 !py-2 text-xs flex-1 sm:flex-none">
              {t("cookie.accept")}
            </button>
            <button data-testid="cookie-reject" onClick={() => choose("rejected")}
              className="kc-btn-ghost !px-5 !py-2 text-xs flex-1 sm:flex-none">
              {t("cookie.reject")}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
